module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_3.d7f83604feec80ad5cdffe40273023b8.png";